<template>
  <div>
    <b-container class="margin-lg">
      <nav-bar
        :title="
          parseInt(coin.type_code) == 7
            ? 'Approve planning coins'
            : parseInt(coin.type_code) == 1 || parseInt(coin.type_code) == 3
            ? 'Approve Tasks coins'
            : ''
        "
      ></nav-bar>

      <plan-detail
        v-if="parseInt(coin.type_code) == 7"
        :id="parseInt(coin.module)"
        :plan="getPlanByModule(parseInt(coin.module))"
      ></plan-detail>

      <task-detail
        v-if="parseInt(coin.type_code) == 1 || parseInt(coin.type_code) == 3"
        :Tid="parseInt(coin.id_related)"
        :inCoins="true"
      ></task-detail>

      <!--criterion-list
        v-if="$route.params.code == 4"
        :checklist="getModuleCheckList"
        :module="$route.params.idRelated"
       ></criterion-list-->

      <allow-coins
        class="bg-light w-100 shadow-lg d-block p-4 fixed-bottom"
        :coins="parseInt(coin.value)"
        :idCoins="parseInt(coin.id)"
      ></allow-coins>
    </b-container>
  </div>
</template>

<script>
import store from '@/store';
import { mapGetters } from 'vuex';
import navBar from '@/components/atmNavBar';
import allowCoins from '@/components/atmAllowCoins';
import planDetail from '@/components/Plan/atmPlanDetail';
import taskDetail from '@/components/Tasks/atmTaskDetail';
import criterionList from '@/components/Checklist/atmCriterionList';

export default {
  components: {
    navBar,
    allowCoins,
    planDetail,
    taskDetail,
    criterionList
  },
  computed: {
    ...mapGetters('user', ['userIsAParent']),
    ...mapGetters('coins', ['getChildCoinsBanked', 'getDetailCoin']),
    ...mapGetters('plan', ['getPlanByModule']),
    ...mapGetters('checklist', ['getModuleCheckList']),
    coin() {
      return this.getDetailCoin(this.$route.params.id);
    }
  },
  async beforeRouteEnter(to, from, next) {
    const childId = store.getters['user/userIsAParent']
      ? store.getters['user/getChildSelectedId']
      : store.getters['user/getUserId'];

    await Promise.all([
      store.dispatch('task/fetchAllTasks', { childId }),
      store.dispatch('plan/fetchAllPlans', childId),
      store.dispatch('coins/getChildCoinsPending', childId)
    ]);
    next();
  }
};
</script>
<style scoped>
.margin-lg {
  margin-bottom: 250px;
}
</style>
